<template>
  <div class="search-wrap">
    <form @submit.prevent="emmiter">
      <span class="is--icon">
        <i class="ri-search-line"></i>
      </span>
      <span class="is--clear" v-if="searchString" @click="clear">
        <i class="ri-close-circle-fill"></i>
      </span>
      <input type="text" :placeholder="'d_ws_search_placeholder' | translate" v-model="searchString" @change="emmiter">
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchString: ''
    }
  },
  methods: {
    clear() {
      this.searchString = '';
      this.emmiter();
    },
    emmiter() {
      this.$emit('change', this.searchString.trim().toLocaleLowerCase());
    }
  },
  watch: {
    searchString(value) {
      this.emmiter();
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-wrap {
    width: 100%;
    form {
      position: relative;
      input[type="text"] {
        height: 36px;
        width: 100%;
        background: var(--light-01);
        border-radius: 60px;
        border: 2px solid var(--accent-blue);
        padding: 0 36px;
        color: var(--accent-blue);
        font-weight: 500;
        font-size: 16px;
        &::placeholder {
          font-weight: 500;
        }
      }
      span {
        &.is--icon {
          position: absolute;
          font-size: 20px;
          top: 8px;
          left: 8px;
          color: var(--accent-blue);
        }
        &.is--clear {
          position: absolute;
          font-size: 20px;
          right: 8px;
          top: 8px;
          color: var(--accent-blue);
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width: 425px) {
    .search-wrap {
      position: absolute;
      left: 44px;
      top: 0;
      height: 100%;
      width: calc(100% - 44px);
      form {
        height: 100%;
        span.is--icon {
          display: none;
        }
        span.is--clear {
          top: 14px;
          right: 14px;
        }
        input[type="text"] {
          height: 100%;
          border: none;
          padding-left: 0;
        }
      }
    }
  }
</style>
